
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/addPanelInfra/newAddPanel/sectionView.scss.css.virtualfile';
        module.exports = {"sectionView":"_sectionView_aff3l_1"};